import { FHA_CASE_NUMBER_FORMAT, PHONE_NUMBER_FORMAT, SSN_FORMAT } from './ui';

export const FieldInputType = {
  TEXT: 'text',
  RICH_TEXT: 'rich_text',
  TEXT_EXCEPT_DIGITS: 'textExceptDigits',
  TEXT_EXCEPT_SPECIAL_SYMBOLS: 'textExceptSpecialSymbols',
  TEXT_EXCEPT_QUERY_DANGEROUS_SYMBOLS: 'textExceptQueryDangerousSymbols',
  TEXT_SPECIFIC_PATTERN: 'textSpecificPattern',
  INT: 'int',
  FLOAT: 'float',
  EMAIL: 'email',
  TEL: 'tel',
  TEL_EXT: 'tel_ext',
  EXT: 'ext',
  ZIP: 'zip',
  NON_US_ZIP: 'nonUSZip',
  BOOL: 'bool',
  DATE: 'date',
  YEAR: 'year',
  CURRENCY: 'currency',
  SSN: 'ssn',
  PERCENTAGE: 'percentage',
  PERCENTAGE_RESTYLED: 'percentageRestyled',
  FHA_CASE_NUMBER: 'fhaCaseNumber',
};

export const PHONE_FIELD_INPUT_TYPES = [FieldInputType.TEL, FieldInputType.TEL_EXT];

// CAUTION: these props are used around whole application as default. Change it carefully.
export const numberFormatProps = {
  [FieldInputType.CURRENCY]: {
    thousandSeparator: true,
    allowNegative: false,
  },
  [FieldInputType.INT]: {
    decimalScale: 0,
    allowNegative: false,
  },
  [FieldInputType.FLOAT]: {
    allowNegative: false,
  },
  [FieldInputType.SSN]: {
    format: SSN_FORMAT,
    mask: '_',
  },
  [FieldInputType.FHA_CASE_NUMBER]: {
    format: FHA_CASE_NUMBER_FORMAT,
    mask: '_',
  },
  [FieldInputType.TEL]: {
    format: PHONE_NUMBER_FORMAT,
    mask: '_',
  },
  [FieldInputType.TEL_EXT]: {
    format: PHONE_NUMBER_FORMAT,
    mask: '_',
    type: FieldInputType.TEL,
  },
  [FieldInputType.EXT]: {
    decimalScale: 0,
    allowLeadingZeros: true,
  },
  [FieldInputType.PERCENTAGE]: {
    suffix: '%',
    allowNegative: false,
    decimalScale: 0,
  },
  [FieldInputType.PERCENTAGE_RESTYLED]: {
    allowNegative: false,
    decimalScale: 0,
  },
};

export const numberFormatTypes = Object.keys(numberFormatProps);
